import React, { useState, useEffect } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import HomeIcon from "@mui/icons-material/Home";
import { HomeFilledIcon } from "@shopify/polaris-icons";
import SettingsIcon from "@mui/icons-material/Settings";
import sizeConfigs from "./configs/sizeConfigs";
import DeveloperLogin from "../../dev_pages/auth/developer_login";
import AddIcon from "@mui/icons-material/Add";
import { Icon } from "@shopify/polaris";
import { AppsIcon } from "@shopify/polaris-icons";
import { SettingsFilledIcon } from "@shopify/polaris-icons";
import {
  AppsFilledIcon
} from '@shopify/polaris-icons';
const Sidebar = () => {
  const [openNested, setOpenNested] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const storedToken = localStorage.getItem("developer_token");
    console.log('new deployment 1.0');
    // Check if the storedToken matches the expected value
    if (storedToken !== null) {
      console.log("developer_token is successfully set in localStorage.");
    } else {
      window.location.href = "/developer/login";
    }
    // Check if the current location path matches any of the nested routes
    const isNestedRoute = nestedRoutes.some((route) =>
      location.pathname.startsWith(route.path)
    );

    // If a nested route is accessed directly, expand the nested navigation items
    if (isNestedRoute) {
      setOpenNested(true);
    } else {
      setOpenNested(false);
    }
  }, [location.pathname]); // Listen to changes in location.pathname

  const handleNestedClick = () => {
    setOpenNested(!openNested);
  };

  // Define nested routes with icons and names
  const nestedRoutes = [
    { path: "/developer/createApps", icon: <AppsIcon style={{ height: "30px", fill: location.pathname === "/developer/createApps" ? "green" : "gray", }} />, name: "Create Apps" },
  ];

  return (
    <Drawer

      variant="permanent"
      sx={{
        fontFamily: "sfproregular",
        fontSize: "14px",
        width: sizeConfigs.sidebar.width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: sizeConfigs.sidebar.width,
          paddingTop: "70px",
          background: "#f6f6f7",
        },
        "& .MuiListItem-root": {
          height: "32px",
          "&.active": {
            color: "green",
            backgroundColor: "#f0f0f0", // Gray background when selected
          },

          "&:hover": {
            // Remove hover color when not clicked
            backgroundColor: "transparent",
          },
        },

        "& .MuiListItemButton-root": {
          fontFamily: "sfprobold",
          fontWeight: "bold",
          fontSize: "14px",
          paddingLeft: "7px",
          color: "inherit",
          "&.active": {
            color: "green",
          },
          "&:hover": {
            // Remove hover color when not clicked
            backgroundColor: "transparent",
          },
        },
        "& .MuiListItemText-primary": {
          fontFamily: "-apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
          fontSize: "14px",
          fontWeight: "500",
          color: "#202223",
        },
        "& .MuiListItemIcon-root": {
          fontFamily: "sfprobold",
          fontWeight: "700",
          fontSize: "14px",
          justifyContent: "space-around",
          color: "inherit", // Inherit the color from ListItemButton
          "&.active": {
            color: "green", // Change icon color when active
          },
        },
        "& .nested": {
          "&.active": {
            backgroundColor: "#f0f0f0", // Inherit gray background when selected
          },
          "&:hover": {
            backgroundColor: "transparent", // Remove hover color for nested items
          },
        },
      }}
    >
      <List

       className="nav-text"
        disablePadding
      >
        <ListItem


          disablePadding
          className={location.pathname === "/developer" ? "active" : ""}
        >
          <ListItemButton component={Link} to="/developer">
            <ListItemIcon>
              <Icon source={HomeFilledIcon} tone="base" />
            </ListItemIcon>
            <ListItemText className="nav-text" primary="Home" />
          </ListItemButton>
        </ListItem>
        <ListItem
                sx={{paddingTop: "4px",}}
          disablePadding
          button
          onClick={handleNestedClick}
          className={location.pathname === "/developer/apps" ? "active" : ""}
        >
          <ListItemIcon sx={{ paddingLeft: "15px" }}>
            <Icon source={ AppsFilledIcon} tone="base" />
          </ListItemIcon>
          <ListItemButton
            disableRipple
            component={Link}
            to="/developer/apps"
            className={location.pathname === "/developer/apps" ? "active" : ""}
          >
            <ListItemText primary="Apps" sx={{ paddingLeft: "-1px" }} />
          </ListItemButton>
          {/* {openNested ? < ExpandLess  /> : <ExpandMore />} */}
        </ListItem>
        <List
                sx={{paddingTop: "4px",}}
          component="div"
          disablePadding
          style={{ paddingLeft: openNested ? "16px" : "0" }}
        >
          {openNested &&
            nestedRoutes.map((route, index) => (
              <ListItem
                key={index}
                disablePadding
                className={`nested ${location.pathname === route.path ? "active" : ""
                  }`}
              >
                <ListItemButton
                  component={Link}
                  to={route.path}
                  className={location.pathname === route.path ? "active" : ""}
                >
                  <ListItemIcon>{route.icon}</ListItemIcon>
                  <ListItemText primary={route.name} />
                </ListItemButton>
              </ListItem>

            ))}
        </List>
 <div style={{ paddingTop: "4px", marginTop: "auto", marginBottom: "20px" }}>
        <ListItem
          disablePadding
          className={location.pathname === "/developer/settings" ? "active" : ""}
        >
          <ListItemButton component={Link} to="/developer/settings">
            <ListItemIcon>
              <Icon source={SettingsFilledIcon} tone="base" />
            </ListItemIcon>
            <ListItemText primary="Settings" />
          </ListItemButton>
        </ListItem>
      </div>
      </List>

      {/* Settings item at the bottom */}
     
    </Drawer>
  );
};

export default Sidebar;
